// 23/10/2026 owner: the 3 size pickers in the chosen Buy 2/3 card sit on ONE line on phones. When an option name does not fit
// its picker, every option's SHOWN name shortens step by step until all fit (values untouched, so the cart is unchanged);
// full names come back as soon as there is room (desktop, wider phones). Same steps as ChopChop USA's cc.js.
(() => {
  const cvs = document.createElement('canvas').getContext('2d');
  const steps = [
    (t) => t,
    (t) => t.replace(/\s*[×x]\s*(?=\d)/g, '×').replace(/\s+-\s+/g, ' '),          // Medium - 15.2" × 10.4" -> Medium 15.2"×10.4"
    (t) => t.replace(/\b(small|medium|large)\b/gi, (w) => w[0].toUpperCase()),     // Medium -> M
    (t) => t.replace(/\s*\([^)]*\)/g, ''),                                           // 11.02" (28 cm) -> 11.02"
    (t) => t.replace(/\s*·\s*\$[\d,.]+\s*$/, ''),                                    // drop " · $169.95"
    (t) => t.replace(/^(\S+)\s.*$/, '$1'),                                           // M 15.2"×10.4" -> M
  ];
  const fit = (box) => {
    const sels = [...box.querySelectorAll('select.st-bundle__select')];
    if (!sels.length || !sels[0].clientWidth) return; // hidden card: measured when it opens
    const opts = sels.flatMap((s) => [...s.options]);
    opts.forEach((o) => { if (o.dataset.full === undefined) o.dataset.full = o.textContent; });
    const cs = getComputedStyle(sels[0]);
    cvs.font = `${cs.fontWeight} ${cs.fontSize} ${cs.fontFamily}`;
    const room = Math.min(...sels.map((s) => s.clientWidth)) - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight) - 2;
    const shown = (n) => opts.map((o) => steps.slice(0, n + 1).reduce((t, f) => f(t), o.dataset.full));
    let level = 0;
    while (level < steps.length - 1 && shown(level).some((t) => cvs.measureText(t).width > room)) level++;
    const texts = shown(level);
    opts.forEach((o, i) => { if (o.textContent !== texts[i]) o.textContent = texts[i]; });
  };
  const init = () => {
    document.querySelectorAll('[data-tier-sizes]').forEach((box) => {
      if (box.dataset.stFit) return;
      box.dataset.stFit = '1';
      if ('ResizeObserver' in window) new ResizeObserver(() => fit(box)).observe(box);
      fit(box);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('change', (e) => { if (e.target.closest?.('st-bundle-component')) requestAnimationFrame(() => document.querySelectorAll('[data-tier-sizes]').forEach(fit)); });
  document.fonts?.ready.then(() => document.querySelectorAll('[data-tier-sizes]').forEach(fit));
})();
